var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12912",
    "data-name": "Group 12912",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2454",
    "data-name": "Rectangle 2454",
    width: 32,
    height: 32,
    fill: "#00c22d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12911",
    "data-name": "Group 12911",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12917",
    "data-name": "Path 12917",
    d: "M17.652,55.553l-3.511,0a.558.558,0,0,1-.532-.275,7.258,7.258,0,0,0-2.756-2.431c-.089-.046-.175-.1-.276-.153A5.3,5.3,0,0,0,11.9,46.386H30.1V49.96a2.981,2.981,0,0,1,.818-.114,3.135,3.135,0,0,1,.839.116c.082.023.162.05.241.079V45.673c0-.083,0-.167,0-.25a.938.938,0,0,0-.918-.921c-.185-.009-.37,0-.58,0a6.016,6.016,0,0,0-3-5.243,4.511,4.511,0,0,0,.127-6.565,4.456,4.456,0,0,0-5.929-.218,4.292,4.292,0,0,0-1.558,2.766,4.456,4.456,0,0,0,1.454,4.007A6.019,6.019,0,0,0,18.571,44.5H18.2c-2.521,0-5.041,0-7.562-.008a1.331,1.331,0,0,1-.662-.193,5.126,5.126,0,0,0-3.5-.742A5.194,5.194,0,0,0,3,51.732c.3.4.671.757,1.01,1.137-.04.024-.1.064-.163.1A7.373,7.373,0,0,0,.339,57.3c-.161.51-.229,1.05-.339,1.577v1.875a1.068,1.068,0,0,0,.979.688q6.484,0,12.968,0a.928.928,0,0,0,.982-.984c0-.572-.009-1.146-.054-1.716-.034-.43-.129-.855-.2-1.286h2.559a3.013,3.013,0,0,1-.019-.313,2.978,2.978,0,0,1,.435-1.581M24.43,33.33a2.566,2.566,0,0,1,.24,5.126,2.566,2.566,0,1,1-.24-5.126m.089,7.025a4.058,4.058,0,0,1,4.08,4.124H20.473a4.054,4.054,0,0,1,4.046-4.124M3.881,48.685a3.332,3.332,0,1,1,3.333,3.341,3.349,3.349,0,0,1-3.333-3.341m9.155,10.863H1.871a5.448,5.448,0,0,1,2.462-4.663,5.344,5.344,0,0,1,5.847-.258,5.455,5.455,0,0,1,2.855,4.921",
    transform: "translate(0 -29.437)",
    fill: "#00c22d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12918",
    "data-name": "Path 12918",
    d: "M3.574,12.421q6.624.01,13.247,0a1.017,1.017,0,0,0,1-.5,1,1,0,0,0-.135-1.11c-.537-.793-1.071-1.588-1.59-2.392a1.017,1.017,0,0,1-.155-.515c-.012-1.468,0-2.937-.009-4.405A3.276,3.276,0,0,0,14.443.631,8.487,8.487,0,0,0,12.937,0H3A8.7,8.7,0,0,0,1.731.473,3.287,3.287,0,0,0,.059,2.829,1.24,1.24,0,0,1,0,3V9.437a.266.266,0,0,1,.048.076,3.423,3.423,0,0,0,3.525,2.908m-1.7-8.794A1.592,1.592,0,0,1,3.614,1.876q4.356,0,8.713,0A1.589,1.589,0,0,1,14.059,3.6c0,1.52.01,3.04-.006,4.559A1.775,1.775,0,0,0,14.4,9.267c.284.4.544.809.859,1.281H3.726A1.629,1.629,0,0,1,1.875,8.686q0-2.53,0-5.059",
    fill: "#00c22d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12919",
    "data-name": "Path 12919",
    d: "M63.689,56.664c1,.013,2,0,3,0s1.977,0,2.966,0a.935.935,0,1,0,0-1.869c-.812-.014-1.623,0-2.435,0H63.777a.954.954,0,0,0-.972.6.922.922,0,0,0,.883,1.276",
    transform: "translate(-58.717 -51.284)",
    fill: "#00c22d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12920",
    "data-name": "Path 12920",
    d: "M66.626,109.762c-.946-.011-1.893-.006-2.84,0a1.336,1.336,0,0,0-.428.07.924.924,0,0,0-.6.959.885.885,0,0,0,.807.819c.539.03,1.081.007,1.622.007v.015h1.5a.936.936,0,1,0-.062-1.869",
    transform: "translate(-58.739 -102.731)",
    fill: "#00c22d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12921",
    "data-name": "Path 12921",
    d: "M312.037,349.934a1.071,1.071,0,0,0-1.146.366l-.575.609q-2.618,2.778-5.242,5.551c-.2.214-.407.427-.63.662l-.045.047-.105-.124c-.023-.027-.045-.053-.069-.077q-.939-.994-1.879-1.987l-.457-.482a1.148,1.148,0,0,0-.828-.379,1.039,1.039,0,0,0-.729.306,1.026,1.026,0,0,0-.266,1.083,1.252,1.252,0,0,0,.28.461l1.08,1.145.69.729q.471.5.943,1a1.882,1.882,0,0,0,1.352.66,1.567,1.567,0,0,0,.647-.144,2.25,2.25,0,0,0,.7-.516l1.228-1.3,3.477-3.678.41-.433c.552-.581,1.1-1.16,1.644-1.752a1.078,1.078,0,0,0,.289-.722v-.04a1.043,1.043,0,0,0-.772-.982",
    transform: "translate(-280.81 -327.497)",
    fill: "#00c22d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCompleted);
export default __webpack_public_path__ + "static/media/green-completed.c43c8405c30f767923528dd65279c78f.svg";
export { ForwardRef as ReactComponent };